import React from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Provider } from 'react-redux';
import store from './store'
import { NotificationContainer } from 'react-notifications';
import { PublicRoute } from './common/PublicRoutes';
import { PrivateRoute } from './common/PrivateRoutes';
import Login from './pages/Login';
import PgmDetails from './pages/PgmDetails';
import PgmList from './pages/PgmList/index';
import PgmDealers from './pages/PgmDealers';
import Poppup from './component/PoppupQuestionaire';
import NotFoundPage from './pages/NotFound';
import Partner from './pages/Partner';
import BusinessPartners from './pages/BusinessPartners';
import PartsList from './pages/PartsList';
import AddParts from './pages/AddParts';
import ProductTraining from './pages/ProductTraining';
import AddEditContent from './pages/ProductTraining/EditContent';
import PartOrderList from './pages/PartOrderList/index';
import Parts_Lists from './pages/Parts_Lists/index';
import PartCatelogue from './pages/PartCatelogue/index';
import AddEditModules from './pages/AddEditModule';
import EditCatelogue from './pages/EditCatelogue';
import AddCatelogue from './pages/AddCatelogue';
import AddContent from './pages/ProductTraining/AddContent';
import AddModuleConfirmation from './pages/AddEditModule/AddModuleConfirmation';
import EditParts from './pages/EditParts';
import Parts_Lists_Acks from './pages/Parts_Lists_Ack';
import Parts_Lists_dispatch from './pages/Parts_Lists_dispatch';
import Parts_Lists_delevered from './pages/Parts_Lists_delevered/index';
import PgmDeactivateusers from './pages/PgmDeactivateusers';
import EditModules from './pages/EditModule';
import Privacypolicy from './pages/Privacy/Privacypolicy';
import ForgetPasswordForm from './component/forgetpassword/forgetpassword';
import ResetPasswordForm from './component/resetpassword/resetpassword';
import ReturnSignIn from './component/returnsignin/returnsignin';
import KdmPrivacypolicy from './pages/KdmPrivacy/KdmPrivacypolicy';
import { isLogin } from './common/isLogin';
import DeletePgmAccount from './component/DeleteAccount/deleteAccount';
import VerificationOtp from './component/verificationotp/verificationOtp';
import Mxkdmprivacy from './pages/MXKdmPrivacy/mxkdmprivacy';
import Mxprivacy from './pages/MXPrivacy/mxprivacy';
import RolesAndUser from './pages/RolesAndUsers/RolesAndUser';
import UserManagement from './pages/UserManagement/UserManagement';
import CreateRole from './component/createRole/CreateRole';
import CreateUser from './component/CreateUser/CreateUser';
import AddAreaExecutive from './component/AddAreaExecutive/AddAreaExecutive';
import NotificationList from './pages/NotificationList/NotificationList';
import CreateEditNotification from './component/CreateEditNotofication/CreateEditNotification';
import CreateBulkNotification from './component/CreateBulkNotification/CreateEditBulkNotification';
import PrivateLayout from './common/PrivateLayout';

const RouteEndPoint = process.env.REACT_APP_ROUTE_ENDPOINT || "/"

function App() {
  return (
    <div className="App">
      <Provider store={store}>
        <Router basename={RouteEndPoint}>
          <Routes>
            <Route exact path="/" element={<PublicRoute><Login /></PublicRoute>} />
            <Route exact path="/:countryRegion/:countryCode" element={<PublicRoute><Login /></PublicRoute>} />
            <Route exact path="/privacy_policy" element={<PublicRoute><Privacypolicy /></PublicRoute>} />
            <Route exact path="/forgetpassword" element={<PublicRoute><ForgetPasswordForm /></PublicRoute>} />
            <Route exact path="/resetpassword" element={<PublicRoute><ResetPasswordForm /></PublicRoute>} />
            <Route exact path="/passwordconfirmation" element={<PublicRoute><ReturnSignIn /></PublicRoute>} />
            <Route exact path='/useraccount/delete' element={<PublicRoute><DeletePgmAccount /></PublicRoute>} />
            <Route exact path='/verifyOtp' element={<PublicRoute><VerificationOtp /></PublicRoute>} />
            <Route exact path='/mx/privacy_policy' element={<PublicRoute><Mxprivacy /></PublicRoute>} />
            <Route exact path='/mx/kdm_privacy_policy' element={isLogin() ? <PrivateRoute><Mxkdmprivacy /></PrivateRoute> : <PublicRoute><Mxkdmprivacy /></PublicRoute>} />
            <Route exact path="/kdm_privacy_policy" element={isLogin() ? <PrivateRoute><KdmPrivacypolicy /></PrivateRoute> : <PublicRoute><KdmPrivacypolicy /></PublicRoute>} />

            <Route element={<PrivateRoute><PrivateLayout /></PrivateRoute>}>
              <Route exact path="/pgmlist" element={<PgmList />} />
              <Route exact path="/pgmdetails/:id" element={<PgmDetails />} />
              <Route exact path="/pgmdeactivate/:id" element={<PgmDeactivateusers />} />
              <Route exact path="/pgmdealers" element={<PgmDealers />} />
              <Route exact path="/popup" element={<Poppup />} />
              <Route exact path="*" element={<NotFoundPage />} />
              <Route exact path="/partner" element={<Partner />} />
              <Route exact path="/businesspartners/:id" element={<BusinessPartners />} />
              <Route exact path="/partslist" element={<PartsList />} />
              <Route exact path="/parts_lists/:id" element={<Parts_Lists />} />
              <Route exact path="/parts_lists_acks/:id" element={<Parts_Lists_Acks />} />
              <Route exact path="/parts_lists_dispatch/:id" element={<Parts_Lists_dispatch />} />
              <Route exact path="/parts_lists_delevered/:id" element={<Parts_Lists_delevered />} />
              <Route exact path="/productTraining" element={<ProductTraining />} />
              <Route exact path='/editcontent/:id' element={<AddEditContent />} />
              <Route exact path='/addcontent' element={< AddContent />} />
              <Route exact path="/addparts" element={<AddParts />} />
              <Route exact path="/editparts/:id" element={<EditParts />} />
              <Route exact path="/partorderlist" element={<PartOrderList />} />
              <Route exact path="/addeditmodule" element={<AddEditModules />} />
              <Route exact path="/partcatelogue" element={<PartCatelogue />} />
              <Route exact path="/editcatelogue/:id" element={<EditCatelogue />} />
              <Route exact path="/addcatelogue" element={<AddCatelogue />} />
              <Route exact path="/editmodule/:id" element={<EditModules />} />
              <Route exact path="/addmoduleconfirmation/:id" element={<AddModuleConfirmation />} />
              <Route exact path='/roles_and_permission' element={<RolesAndUser />} />
              <Route exact path='/create_role' element={<CreateRole />} />
              <Route exact path='/create_user' element={<CreateUser />} />
              <Route exact path='/edit_user/:userId' element={<CreateUser />} />
              <Route exact path='/add_area_executive' element={<AddAreaExecutive />} />
              <Route exact path="/edit_role/:roleId" element={<CreateRole />} />
              <Route exact path='/user_management' element={<UserManagement />} />
              <Route exact path='/edit_area_executive/:areaExecutiveId' element={<AddAreaExecutive />} />
              <Route exact path='/notification_list' element={<NotificationList />} />
              <Route exact path='/create-notification' element={<CreateEditNotification />} />
              <Route exact path='/edit-notification/:id' element={<CreateEditNotification />} />
              <Route exact path='/create-notification-excel' element={<CreateBulkNotification />} />
              <Route exact path='/edit-notification-excel/:id' element={<CreateBulkNotification />} />
            </Route>
          </Routes>
        </Router>
      </Provider>
      <NotificationContainer enterTimeout={500} leaveTimeout={500} />
    </div>
  );
}

export default App;
